import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Shield, Award, Handshake, Building2 } from "lucide-react";

const TrustBar = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.5 });

  const certifications = [
    { icon: Shield, label: "BAFA-zertifiziert" },
    { icon: Award, label: "INQA-autorisiert" },
    { icon: Handshake, label: "IHK-Partnerin" },
    { icon: Building2, label: "Bizzmade GmbH" },
  ];

  return (
    <section className="py-10 bg-background border-y border-border/50" ref={ref}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="flex flex-wrap justify-center items-center gap-8 md:gap-16"
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.6 }}
        >
          {certifications.map((cert, index) => (
            <motion.div
              key={cert.label}
              className="flex items-center gap-2.5 text-muted-foreground hover:text-foreground transition-colors duration-300 group cursor-default"
              initial={{ opacity: 0, y: 10 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.4, delay: index * 0.1 }}
            >
              <cert.icon className="w-5 h-5 text-accent/60 group-hover:text-accent transition-colors duration-300" strokeWidth={1.8} />
              <span className="text-sm font-medium tracking-wide">{cert.label}</span>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default TrustBar;
